export default __webpack_public_path__ + "static/media/JARDIN.4869d059.jpg";